import React, { useEffect, useRef, useState } from "react";
import '../../../scss/pages/Employee helpdesk/HelpDeskChatbox/HelpDeskChatBox.scss'
import Message from "./Message/Meaasge";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Send from '../../../asset/svg/Send.svg'
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "@mui/material";
import Camera from 'react-html5-camera-photo';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import 'react-html5-camera-photo/build/css/index.css';
import { GET_EMPLOYEE_TICKETS, POST_CREATE_ATTACHMENT, POST_CREATE_TICKET_REPLY, POST_DELETE_ATTACHMENT, POST_DELETE_TICKET_REPLY, POST_GET_EMP_TICKET, POST_UPDATE_TICKET_REPLY, POST_UPDATE_TICKET_STATUS, POST_UPLOAD_FILE_CHAT } from "../../../sagas/type";
import { generateNumRandomId } from "../../../components/common/GenerateRandomId/GenerateRandomId";
import { getLocalStoreString } from "../../../utils/Helper";
import { useSnackbar } from "notistack";
import ClearIcon from '@mui/icons-material/Clear';

const HelpDeskChatBox = (props) => {
    const containerRef = useRef();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { GetEmpTicket } = props;
    const EmployeeID = getLocalStoreString('EmployeeId');
    const { CheckIsiOSDevice, GetTicket } = useSelector(mapStateToProps)
    const [userMessages, setUserMessages] = useState([]);
    const [opponentMessages, setOpponentMessages] = useState([]);
    const [inputText, setInputText] = useState("");
    const [inputImages, setInputImages] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editedMessageIndex, setEditedMessageIndex] = useState(null);
    const [cameraModalOpen, setCameraModalOpen] = useState(false);
    const [facingMode, setFacingMode] = useState('environment');
    const [selectedImageModal, setSelectedImageModal] = useState(false);
    const [addComment, setAddComment] = useState(false)
    const [timeReply, setTimeReply] = useState('');
    const [replyId, setReplyId] = useState('');
    const [attachementImages, setAttachmentImages] = useState([]);
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        const container = containerRef.current;
        container.scrollTop = container.scrollHeight;
    }, [userMessages]);

    useEffect(() => {
        const userReplyData = GetTicket?.replies?.filter((item) => item?.employeeId == EmployeeID) || [];
        setUserMessages(userReplyData);
        const userReplyAdminData = GetTicket?.replies?.filter((item) => item?.employeeId !== EmployeeID) || [];
        setOpponentMessages(userReplyAdminData);
    }, [GetTicket?.replies]);



    const getCurrentTime = () => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const now = new Date();
        const day = now.getDate().toString().padStart(2, "0");
        const month = months[now.getMonth()];
        const year = now.getFullYear();
        const hours = now.getHours().toString().padStart(2, "0");
        const minutes = now.getMinutes().toString().padStart(2, "0");
        const seconds = now.getSeconds().toString().padStart(2, "0")

        return `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}`;
    };

    const handleTextChange = (e) => {
        setInputText(e.target.value);
    };

    const handleClose = (event, reason) => {
        if (reason !== "backdropClick") {
            setOpen(false);
        }
    };

    const switchCamera = () => {
        setFacingMode(prevMode => (prevMode === 'environment' ? 'user' : 'environment'));
    };

    const handleImageChange = (e) => {
        const files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            const file = files[i]
            dispatch({
                type: POST_UPLOAD_FILE_CHAT,
                payload: { file },
                enqueueSnackbar: enqueueSnackbar,
                setSelectedImageModal: setSelectedImageModal,
                setInputImages: setInputImages,
                inputImages: inputImages,
                setAttachmentImages: setAttachmentImages,
                attachementImages: attachementImages,
                enqueueSnackbar: enqueueSnackbar,
            })
        }
    };

    const handleEditClick = (index, reply_id) => {
        setEditMode(true);
        setReplyId(reply_id)
        setEditedMessageIndex(index);
        setInputText(userMessages[index]?.description);
        setInputImages(userMessages[index]?.attachments);
        setTimeReply(userMessages[index]?.createdDate)
        if (userMessages[index]?.attachments?.length > 0) {
            setSelectedImageModal(true)
        }
    };

    const handleSendMessage = () => {
        if (inputText || inputImages?.length > 0) {
            setAddComment(false)
            const currentTime = getCurrentTime();
            const updatedMessages = [...userMessages];
            if (editMode && editedMessageIndex !== null) {
                const random_Id = generateNumRandomId(8)
                const EmployeeID = getLocalStoreString('EmployeeId');
                const TenantId = getLocalStoreString("CompanyID");
                updatedMessages[editedMessageIndex] = {
                    ...updatedMessages[editedMessageIndex],
                    description: inputText,
                    images: inputImages,
                    createdDate: timeReply,
                };
                if (attachementImages.length > 0) {
                    const EmployeeID = getLocalStoreString('EmployeeId');
                    const TenantId = getLocalStoreString("CompanyID");
                    const randomId = generateNumRandomId(8)
                    const newAttachmnet = {
                        traceId: randomId,
                        employeeId: EmployeeID,
                        companyId: TenantId,
                        ticketNo: GetEmpTicket?.ticketNo,
                        replyId: replyId,
                        attachments: attachementImages,
                    }
                    dispatch({
                        type: POST_CREATE_ATTACHMENT,
                        payload: newAttachmnet,
                        setAttachmentImages: setAttachmentImages,
                        UpdateReplyTicket: UpdateReplyTicket,
                    })
                }
                const updateReply = {
                    traceId: random_Id,
                    employeeId: EmployeeID,
                    companyId: TenantId,
                    ticketNo: GetEmpTicket?.ticketNo,
                    replyId: replyId,
                    description: inputText
                }
                dispatch({
                    type: POST_UPDATE_TICKET_REPLY,
                    payload: updateReply,
                    setAttachmentImages: setAttachmentImages,
                    UpdateReplyTicket: UpdateReplyTicket,
                    setSelectedImageModal: setSelectedImageModal
                })
            } else {
                const objAttachments = [{
                    id: '',
                    attachmentUrl: '',
                    attachmentType: '',
                }]
                const EmployeeID = getLocalStoreString('EmployeeId');
                const TenantId = getLocalStoreString("CompanyID");
                const randomId = generateNumRandomId(8)
                const replyTicket = {
                    traceId: randomId,
                    employeeId: EmployeeID,
                    companyId: TenantId,
                    ticketNo: GetEmpTicket?.ticketNo,
                    description: inputText,
                    attachments: inputImages?.length > 0 ? inputImages : objAttachments,
                }
                dispatch({
                    type: POST_CREATE_TICKET_REPLY,
                    payload: replyTicket,
                    UpdateReplyTicket: UpdateReplyTicket,
                    setSelectedImageModal: setSelectedImageModal
                })
                const newMessage = {
                    employeeName: GetEmpTicket?.employeeName,
                    description: inputText,
                    images: inputImages,
                    createdDate: currentTime,
                };
                updatedMessages?.push(newMessage);
            }
            setUserMessages(updatedMessages);
            setEditMode(false);
            setEditedMessageIndex(null);

            // setTimeout(() => {
            //     const opponentReply = {
            //         employeeName: "Rahul Jaiswal",
            //         description: "Random reply from opponent",
            //         images: [],
            //         createdDate: getCurrentTime(),
            //         isUser: false,
            //     };
            //     setOpponentMessages([...opponentMessages, opponentReply]);
            // }, 1000);

            setInputText("");
            setInputImages([]);
            setAttachmentImages([])
            console.log("GetEmpTicket", GetEmpTicket);
        }
        setLoader(true)
        const EmployeeID = getLocalStoreString('EmployeeId');
        const TenantId = getLocalStoreString("CompanyID");
        const randomId = generateNumRandomId(8);
        const reqGetTickets = {
            traceId: randomId,
            employeeId: EmployeeID,
            companyId: TenantId,
        }
        dispatch({
            type: GET_EMPLOYEE_TICKETS,
            payload: reqGetTickets,
            setLoader: setLoader,
        })
    };

    const handleMarkAsResolved = () => {
        const EmployeeID = getLocalStoreString('EmployeeId');
        const TenantId = getLocalStoreString("CompanyID");
        const randomId = generateNumRandomId(8);
        const resolvedRequest = {
            traceId: randomId,
            employeeId: EmployeeID,
            companyId: TenantId,
            ticketNo: GetEmpTicket?.ticketNo,
            status: "CLOSED",
        }
        dispatch({
            type: POST_UPDATE_TICKET_STATUS,
            payload: resolvedRequest,
            UpdateReplyTicket: UpdateReplyTicket,
        })
    }
    const handleAddComment = () => {
        setAddComment(true)
    }

    const handleReOpen = () => {
        const EmployeeID = getLocalStoreString('EmployeeId');
        const TenantId = getLocalStoreString("CompanyID");
        const randomId = generateNumRandomId(8);
        const resolvedRequest = {
            traceId: randomId,
            employeeId: EmployeeID,
            companyId: TenantId,
            ticketNo: GetEmpTicket?.ticketNo,
            status: "INPROGRESS",
        }
        dispatch({
            type: POST_UPDATE_TICKET_STATUS,
            payload: resolvedRequest,
            UpdateReplyTicket: UpdateReplyTicket,
        })
    }

    const handleDeleteReplyMessage = (index, replyId) => {
        const EmployeeID = getLocalStoreString('EmployeeId');
        const TenantId = getLocalStoreString("CompanyID");
        const randomId = generateNumRandomId(8);
        const deleteMessage = {
            traceId: randomId,
            employeeId: EmployeeID,
            companyId: TenantId,
            ticketNo: GetEmpTicket?.ticketNo,
            replyId: replyId,
        }

        dispatch({
            type: POST_DELETE_TICKET_REPLY,
            payload: deleteMessage,
            updateDeleteReply: UpdateReplyTicket
        })
    }

    const UpdateReplyTicket = () => {
        const EmployeeID = getLocalStoreString('EmployeeId');
        const TenantId = getLocalStoreString("CompanyID");
        const randomId = generateNumRandomId(8);
        const getTicketReq = {
            traceId: randomId,
            employeeId: EmployeeID,
            companyId: TenantId,
            ticketNo: GetEmpTicket?.ticketNo,
        }
        dispatch({
            type: POST_GET_EMP_TICKET,
            payload: getTicketReq,
        })
    }

    const handleDeleteAttachment = (AttachmentId) => {
        const EmployeeID = getLocalStoreString('EmployeeId');
        const TenantId = getLocalStoreString("CompanyID");
        const randomId = generateNumRandomId(8);
        const deleteAttachment = {
            traceId: randomId,
            employeeId: EmployeeID,
            companyId: TenantId,
            ticketNo: GetEmpTicket?.ticketNo,
            attachmentId: AttachmentId,
        }

        dispatch({
            type: POST_DELETE_ATTACHMENT,
            payload: deleteAttachment,
            UpdateReplyTicket: UpdateReplyTicket,
        })
        const deleteAttachmnetState = inputImages?.filter((item) => item?.id !== AttachmentId)
        setInputImages(deleteAttachmnetState)
        const deleteAttachementImages = attachementImages?.filter((item) => item?.id !== AttachmentId)
        setAttachmentImages(deleteAttachementImages)
    }

    useEffect(() => {
        inputImages?.filter(item => {
            if (item?.attachmentUrl == '') {
                setSelectedImageModal(false)
            } else {
                setSelectedImageModal(true)
            }
        })
    }, [inputImages])

    return (
        <div className="HelpDesk-ChatBox-container">
            <div className="HelpDesk-ChatBox-container_Meaasage">
                <div className="HelpDesk-ChatBox-container_Meaasage_message-list" ref={containerRef}>
                    {[...userMessages, ...opponentMessages]
                        .sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate))
                        .map((message, index) => {
                            return (
                                <Message
                                    key={index}
                                    name={message.employeeName}
                                    text={message.description}
                                    files={message?.iamges || message?.attachments}
                                    isUser={message.employeeId == EmployeeID ? true : false}
                                    time={message.createdDate}
                                    onEdit={() => handleEditClick(index, message?.id)}
                                    onDelete={() => handleDeleteReplyMessage(index, message?.id)}
                                    addComment={addComment}
                                    setAddComment={setAddComment}
                                />
                            );
                        })}
                    {selectedImageModal && inputImages?.length > 0 && <div className="HelpDesk-ChatBox-container_Meaasage_message-list_Selected-img">
                        {inputImages?.length > 0 && inputImages?.filter((item) => item.attachmentUrl !== "").map((image) => {
                            return (
                                <div key={image?.id} className="HelpDesk-ChatBox-container_Meaasage_message-list_Selected-img_img">
                                    <img src={image?.attachmentUrl} />
                                    <ClearIcon sx={{ width: "16px", height: "16px", color: "#FFF", position: "absolute", top: 5, right: 10, backgroundColor: 'rgba(255, 255, 255, 0.10)', borderRadius: '50%', padding: '2px', border: ' 1px solid rgba(255, 255, 255, 0.12)' }} onClick={() => handleDeleteAttachment(image?.id)} />
                                </div>
                            )
                        })
                        }
                    </div>}
                </div>
            </div>
            {addComment && <div className="HelpDesk-ChatBox-container_input-container">
                <textarea
                    type="text"
                    value={inputText}
                    onChange={handleTextChange}
                    placeholder="Write Something"
                />
                <div className="HelpDesk-ChatBox-container_input-container_flexbox">
                    {CheckIsiOSDevice !== 'iOS' && <div className="HelpDesk-ChatBox-container_input-container_flexbox_label-camera-send">
                        <label htmlFor="imageFile">
                            <CameraAltIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '20px', width: '20px' }} />
                        </label>
                        <input type="file" id="imageFile" capture="environment" accept="image/*" onChange={handleImageChange} multiple />
                    </div>}

                    {CheckIsiOSDevice == 'iOS' && <div className="HelpDesk-ChatBox-container_input-container_flexbox_label-camera-send">
                        <label htmlFor="imageFile">
                            <CameraAltIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '20px', width: '20px' }} />
                        </label>
                        <input type="file" id="imageFile" capture="environment" accept="image/*" onChange={handleImageChange} multiple />
                    </div>}
                    <Modal
                        open={cameraModalOpen}
                        onClose={handleClose}
                        aria-labelledby="camera-modal-title"
                        aria-describedby="camera-modal-description"
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", backgroundColor: "rgb(0.0.0.1)" }}
                    >
                        <div className='Asset-Info-Container_camera-modal'>
                            <Camera
                                onTakePhoto={(dataUri) => capture(dataUri)}
                                onCameraError={(error) => console.error('Camera error', error)}
                                idealFacingMode={facingMode}
                                isFullscreen={true}
                                isImageMirror={false}
                                isSilentMode={true}
                                isDisplayStartCameraError={false}
                                sizeFactor={1}
                            />
                            <div style={{ display: "flex", position: "absolute", bottom: "20px", width: "100%", justifyContent: "space-around", alignItems: "center" }} className='Asset-Info-Container_registerData_buttonContainer'>
                                <HighlightOffIcon className='Asset-Info-Container_registerData_buttonContainer_active-button-camera' sx={{ width: "25px", height: "25px", color: "#FFF", left: 2 }} onClick={() => setCameraModalOpen(false)} />
                                <FlipCameraIosIcon className='Asset-Info-Container_registerData_buttonContainer_active-button-camera' sx={{ width: "25px", height: "25px", color: "#FFF", right: 2 }} onClick={switchCamera} />
                            </div>
                        </div>
                    </Modal>
                    <button disabled={inputText == ""} onClick={handleSendMessage} style={inputText == '' ? { opacity: 0.5 } : { opacity: 1 }}>
                        <img src={Send} width={18} height={18} />
                    </button>
                </div>
            </div>}
            {!addComment && <div className='HelpDesk-ChatBox-container_buttonContainer'>
                {GetTicket.status == 'NEW' || GetTicket.status == 'INPROGRESS' ? <button type='submit' className='HelpDesk-ChatBox-container_buttonContainer_active-button-resolve' onClick={handleMarkAsResolved}>Mark as Resolved</button>
                    : <button type='submit' className='HelpDesk-ChatBox-container_buttonContainer_active-button-resolve' onClick={handleReOpen}>Reopen</button>
                }
                <button type='submit' className='HelpDesk-ChatBox-container_buttonContainer_active-button' onClick={handleAddComment}>Add Comment</button>
            </div>}
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        CheckIsiOSDevice: state?.attendanceConfig?.CheckIsiOSDevice,
        GetTicket: state?.employeeHelpdesk?.GetEmpTicket,

    }
}

export default HelpDeskChatBox;